import {
  DE,
  DK,
  ES,
  FI,
  type FlagComponent,
  FR,
  GB,
  IT,
  NO,
  PL,
  PT,
  SE,
  US,
} from "country-flag-icons/react/3x2";
import { useMemo } from "react";
import type { LanguageComboBoxOptionType } from "./select-language-menu";

type FlagProps = {
  languageOption: LanguageComboBoxOptionType;
};

const flags = {
  da: DK,
  de: DE,
  "en-GB": GB,
  "en-US": US,
  es: ES,
  fi: FI,
  fr: FR,
  it: IT,
  nb: NO,
  pl: PL,
  "pt-PT": PT,
  sv: SE,
};

export default function CountryFlag({ languageOption }: FlagProps) {
  const Flag = useMemo(
    (): FlagComponent => flags[languageOption.value],
    [languageOption.value]
  );

  return <Flag />;
}
